import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  hide(): void {
    queueMicrotask(() => this.loadingSubject.next(false));
  }

  show(): void {
    queueMicrotask(() => this.loadingSubject.next(true));
  }
}
